<div class="fc-order-matrix-wrapper" data-e2e-hook="order-matrix" (scroll)="onScroll($event)">
    <table
        #matrixTable
        cellspacing="0"
        cellpadding="0"
        [formGroup]="form"
        class="fc-order-matrix"
        [ngClass]="{
            'fc-order-matrix-full-width': matrixType === MatrixType.Prepacks,
            'zebra-styling-enabled': matrixConfig.zebraStyle,
            'sticky-header': matrixConfig.useStickyHeader
        }"
    >
        <thead
            fc-order-matrix-headers
            [headers]="topHeaders"
            [groupedHeaders]="matrixConfig.groupedHeaders"
            [useGroupedHeaders]="matrixConfig.useGroupedHeaders"
            [invertGroupedHeaders]="matrixConfig.invertGroupedHeaders"
            [useStickyHeader]="matrixConfig.useStickyHeader"
            [tooltips]="topHeadersTooltip"
            [headerStoreIds]="topHeaderStoreIds"
            [headerHoverDisplayMap]="topHeadersHoverDisplayMap"
            [type]="matrixType"
            [capitalizeHeaders]="capitalizeHeaders()"
            [showCopy]="matrixConfig.showCopy"
            [enableHoverAndCopy]="matrixConfig.enableHoverAndCopy"
            *ngIf="matrixConfig.showHeader"
            [useTooltip]="matrixConfig.useTooltip"
            (onCopy)="onCopyDropdownMenuClick($event)"
            [hideFirstCell]="matrixConfig.hideFirstCell"
        ></thead>
        <ng-container formArrayName="rows">
            <tbody>
                <ng-container *ngFor="let row of rows.controls; let rowIndex = index; trackBy: trackByIndex">
                    <tr [formGroup]="row" [class.fc-order-matrix-prepack-data-row]="isPrepack()">
                        <td
                            class="fc-order-matrix-cell-border"
                            *ngIf="!(matrixConfig.skipEmptyLeftHeaders && !leftHeaders[rowIndex])"
                        >
                            <fc-matrix-cell
                                [type]="isPrepack() ? 'prepackTextTitle' : 'bodyTextTitle'"
                                [isFooter]="isFooterCell(rowIndex)"
                            >
                                <div>
                                    <div *ngIf="isFooterCell(rowIndex)">
                                        {{ leftHeaders[rowIndex] }}
                                    </div>
                                    <div *ngIf="!isFooterCell(rowIndex)">
                                        <fcp-ellipsis-tooltip-text
                                            *ngIf="matrixConfig.useTooltip; else simpleText"
                                            [text]="
                                                matrixConfig.capitalizeLeftHeaders
                                                    ? (leftHeaders[rowIndex] | uppercase)
                                                    : leftHeaders[rowIndex]
                                            "
                                        >
                                        </fcp-ellipsis-tooltip-text>
                                        <ng-template #simpleText>
                                            {{
                                                matrixConfig.capitalizeLeftHeaders
                                                    ? (leftHeaders[rowIndex] | uppercase)
                                                    : leftHeaders[rowIndex]
                                            }}
                                        </ng-template>
                                    </div>
                                    <ng-container *ngIf="isPrepack()">
                                        <div>{{ getPrepackTitle(rowIndex).itemCount }} items</div>
                                        <div>{{ 'ORDER.PRODUCT_DETAILS.TOTAL_ITEMS' | translate }}:</div>
                                    </ng-container>
                                </div>
                            </fc-matrix-cell>
                        </td>
                        <ng-container formArrayName="row">
                            <ng-container
                                *ngFor="
                                    let size of getRow(rowIndex).controls;
                                    let columnIndex = index;
                                    trackBy: trackByIndex
                                "
                            >
                                <td
                                    [formGroup]="size"
                                    class="fc-order-matrix-cell-border"
                                    [ngClass]="{
                                        'fc-order-matrix-cell-border-right': groupedHeadersSizes.includes(
                                            columnIndex + 1
                                        )
                                    }"
                                >
                                    <ng-container *ngIf="cellExists(rowIndex, columnIndex)">
                                        <ng-container
                                            *ngIf="isInteractiveCell(getCell(rowIndex, columnIndex)); else readOnlyCell"
                                        >
                                            <fc-matrix-cell [type]="isPrepack() ? 'prepackInput' : 'bodyInput'">
                                                <div>
                                                    <fc-order-input-cell
                                                        ngDefaultControl
                                                        [cell]="filteredDataSource[rowIndex][columnIndex]"
                                                        [formControlName]="'input'"
                                                        [tooltipTemplateRef]="tooltipTemplateRef"
                                                        (blur)="onInputBlur($event)"
                                                        (keyboardNavigate)="
                                                            inputKeyboardNavigated($event, rowIndex, columnIndex)
                                                        "
                                                        [rowIndex]="rowIndex"
                                                        [columnIndex]="columnIndex"
                                                        [wide]="matrixConfig.wideInput"
                                                    >
                                                    </fc-order-input-cell>
                                                    <div class="fc-matrix-prepack-total-amount" *ngIf="isPrepack()">
                                                        {{ getPrepackTitle(rowIndex).totalItems }}
                                                    </div>
                                                </div>
                                            </fc-matrix-cell>
                                        </ng-container>
                                        <ng-template #readOnlyCell>
                                            <ng-container *ngLet="getCell(rowIndex, columnIndex) as currentCell">
                                                <fc-matrix-cell
                                                    [type]="this.getCellType(currentCell, rowIndex)"
                                                    [isFooter]="isFooterCell(rowIndex)"
                                                >
                                                    <div
                                                        *ngFor="
                                                            let prepackLabel of getPrepackLabels(rowIndex, columnIndex);
                                                            trackBy: trackByIndex
                                                        "
                                                    >
                                                        <div
                                                            class="fc-order-matrix-readonly-label-wrapper"
                                                            (mouseenter)="toggleTooltip(true, rowIndex, columnIndex)"
                                                            (mouseleave)="toggleTooltip(false, rowIndex, columnIndex)"
                                                        >
                                                            <span cdkOverlayOrigin #cellOverlay="cdkOverlayOrigin">{{
                                                                prepackLabel.name
                                                            }}</span>
                                                        </div>
                                                        <fcp-tooltip
                                                            *ngIf="getCellTooltip(rowIndex, columnIndex)"
                                                            [open]="cellTooltipDisplay[rowIndex][columnIndex]"
                                                            [overlayOrigin]="cellOverlay"
                                                            [customPosition]="cellTooltipPosition"
                                                        >
                                                            <div>
                                                                {{ getCellTooltip(rowIndex, columnIndex) | translate }}
                                                            </div>
                                                        </fcp-tooltip>
                                                        <span *ngIf="isPrepack()"> ({{ prepackLabel.count }}) </span>
                                                        <ng-container *ngIf="currentCell.iconTooltip as iconTooltip">
                                                            <span
                                                                cdkOverlayOrigin
                                                                #cellIcon="cdkOverlayOrigin"
                                                                style="
                                                                    margin-left: 6px;
                                                                    color: var(--interactive-01);
                                                                    cursor: pointer;
                                                                "
                                                                (mouseenter)="
                                                                    toggleBackorderIconTooltip(
                                                                        rowIndex,
                                                                        columnIndex,
                                                                        true
                                                                    )
                                                                "
                                                                (mouseleave)="
                                                                    toggleBackorderIconTooltip(
                                                                        rowIndex,
                                                                        columnIndex,
                                                                        false
                                                                    )
                                                                "
                                                            >
                                                                <fcp-icon [icon]="['far', 'calendar-days']"></fcp-icon>
                                                            </span>
                                                            <fcp-tooltip
                                                                [open]="
                                                                    isBackorderIconTooltipVisible(rowIndex, columnIndex)
                                                                "
                                                                [overlayOrigin]="cellIcon"
                                                                [customPosition]="backorderIconTooltipPosition"
                                                            >
                                                                <div>{{ iconTooltip.available }}</div>
                                                                {{ iconTooltip.backorder }}
                                                            </fcp-tooltip>
                                                        </ng-container>
                                                    </div>
                                                </fc-matrix-cell>
                                            </ng-container>
                                        </ng-template>
                                    </ng-container>
                                </td>
                            </ng-container>
                        </ng-container>
                    </tr>
                </ng-container>
            </tbody>
        </ng-container>
    </table>
    @if (matrixConfig.showErrors) {
        <div class="fc-order-matrix-errors">
            <span *ngFor="let error of getErrors()">
                {{ error }}
            </span>
        </div>
    }
</div>
